<template>
	<div>
		<div v-if="!assurance || !userLoan">
			اطلاعات کامل نمی باشد
		</div>
		<div style="direction: rtl;" v-else>
			<div style="text-align: center;margin-bottom: 15px;font-size: 10pt;position: relative;">
				بسمه تعالی
				<div style="position: absolute;left: 0;top: 0;font-size: 10pt;">
					تاریخ: {{ new Date().toLocaleDateString('fa-IR').toString().toPersianDigits() }}
				</div>
			</div>
			<div style="text-align: right;margin-bottom: 15px;">
				با سلام و احترام،
			</div>
			<div style="text-align: justify;line-height: 2;margin-bottom: 15px;">
				اینجانب آقا/خانم <b>{{ userLoan.memberModel.fullName }}</b> با کدملی <b>{{ userLoan.memberModel.nationalCode.toPersianDigits() }}</b>
				مجموعا مبلغ <b>{{ String(userLoan.payableAmount).toPriceFormat().toPersianDigits() }}</b> تومان بابت دریافت خدمات/خرید کالا به
				{{ businessTitle.toPersianDigits() }} بدهکار می باشم که در ازای آن <b>{{ assuranceTitle }} </b> به
				<b>{{ businessTitle.toPersianDigits() }}</b> ارائه می دهم. بدیهی است در صورت تاخیر حداکثر ۵ روزه در پرداخت هر کدام از اقساط، طلای ضمانت داده شده
				متعلق به {{ businessTitle.toPersianDigits() }} می باشد و اینجانب هیچ گونه مالکیتی از کل آن ندارم و
				{{ businessTitle.toPersianDigits() }} حق فروش طلا را دارد. این قرارداد قطعی و غیر قابل تغییر می باشد.
			</div>
			<div style="display: flex;justify-content: space-between;padding: 20px">
				<div>اثر انگشت و امضا مدیریت</div>
				<div>اثر انگشت و امضا ارائه دهنده طلا</div>
			</div>

			<div style="display: flex;flex-wrap: wrap;justify-content: space-between;align-items: flex-start;">
				<table style="border-collapse: collapse;margin-top: 15px;margin-bottom: 35px;border:1px solid #000;" :style="{ width: userLoan.loanPayments.length > 8 ? '48%' : '100%' }">
					<thead>
						<tr>
							<th style="width: 10%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">ردیف</th>
							<th style="width: 45%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ قسط</th>
							<th style="width: 45%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;">مبلغ قسط</th>
						</tr>
					</thead>
					<tbody>
						<tr style="" v-for="(payment, index) in userLoan.loanPayments" :key="payment.id" v-if="index < 8">
							<td style="padding: 5px 10px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ String(index + 1).toPersianDigits() }}</td>
							<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ payment.targetMonth_Persian.date.toPersianDigits() }}</td>
							<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;">{{ String(payment.installmentAmount).toPriceFormat().toPersianDigits() }}</td>
						</tr>
					</tbody>
				</table>
				<table v-if="userLoan.loanPayments.length > 8" style="border-collapse: collapse;margin-top: 15px;margin-bottom: 35px;border:1px solid #000;width: 48%;">
					<thead>
						<tr>
							<th style="width: 10%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">ردیف</th>
							<th style="width: 45%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ قسط</th>
							<th style="width: 45%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;">مبلغ قسط</th>
						</tr>
					</thead>
					<tbody>
						<tr style="" v-for="(payment, index) in userLoan.loanPayments" :key="payment.id" v-if="index > 7 && index < 16">
							<td style="padding: 5px 10px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ String(index + 1).toPersianDigits() }}</td>
							<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ payment.targetMonth_Persian.date.toPersianDigits() }}</td>
							<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;">{{ String(payment.installmentAmount).toPriceFormat().toPersianDigits() }}</td>
						</tr>
					</tbody>
				</table>
				<table v-if="userLoan.loanPayments.length > 16" style="border-collapse: collapse;margin-top: 15px;margin-bottom: 35px;border:1px solid #000;width: 100%">
					<thead>
						<tr>
							<th style="width: 10%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">ردیف</th>
							<th style="width: 45%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ قسط</th>
							<th style="width: 45%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;">مبلغ قسط</th>
						</tr>
					</thead>
					<tbody>
						<tr style="" v-for="(payment, index) in userLoan.loanPayments" :key="payment.id" v-if="index > 15">
							<td style="padding: 5px 10px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ String(index + 1).toPersianDigits() }}</td>
							<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ payment.targetMonth_Persian.date.toPersianDigits() }}</td>
							<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;">{{ String(payment.installmentAmount).toPriceFormat().toPersianDigits() }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<table style="border-collapse: collapse;width: 100%;border-top: 2px solid #000;border-bottom: 2px solid #000;margin-bottom: 35px;">
				<tbody>
					<tr style="">
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">مبلغ کل خدمات دریافت شده</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px dashed #000;font-weight: bold;">{{ String(userLoan.amount + userLoan.preDepositAmount).toPriceFormat().toPersianDigits() }}</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">مجموع باقی مانده و سود</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;font-weight: bold;">{{ String(userLoan.payableAmount).toPriceFormat().toPersianDigits() }}</td>
					</tr>
					<tr style="">
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">پیش پرداخت</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px dashed #000;font-weight: bold;">{{ String(userLoan.preDepositAmount).toPriceFormat().toPersianDigits() }}</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">تعداد اقساط</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;font-weight: bold;">{{ String(userLoan.month).toPersianDigits() }}</td>
					</tr>
					<tr style="">
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">باقی مانده</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px dashed #000;font-weight: bold;">{{ String(userLoan.amount).toPriceFormat().toPersianDigits() }}</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">مبلغ هر قسط</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;font-weight: bold;">{{ String(userLoan.installment).toPriceFormat().toPersianDigits() }}</td>
					</tr>
					<tr style="">
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">سود</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px dashed #000;font-weight: bold;">{{ String(userLoan.payableAmount - userLoan.amount).toPriceFormat().toPersianDigits() }}</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">تاریخ</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;font-weight: bold;">{{ userLoan.startDate_Persian.date.toPersianDigits() }}</td>
					</tr>
					<tr style="">
						<td colspan="4" style="padding: 5px;text-align: center;font-size: 10pt;">
							ارزش کل خدمات دریافتی به صورت اقساطی <span style="font-weight: bold;margin-right: 15px;">{{ String(userLoan.amount + userLoan.preDepositAmount).toPriceFormat().toPersianDigits() }} تومان</span>
						</td>
					</tr>
				</tbody>
			</table>

			<table style="border-collapse: collapse;width: 100%;">
				<thead>
					<tr>
						<th style="width: 10%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">ردیف</th>
						<th style="width: 33%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ دریافت خدمات اقساطی</th>
						<th style="width: 37%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">خدمات دریافت شده اقساطی</th>
						<th style="width: 20%;padding: 5px;text-align: center;font-size: 12pt;border-bottom: 1px solid #000;">مبلغ خدمات</th>
					</tr>
				</thead>
				<tbody>
					<tr style="" v-for="r in 6" :key="r">
						<td style="padding: 5px 10px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ String(r).toPersianDigits() }}</td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
						<td style="padding: 5px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;"></td>
					</tr>
				</tbody>
			</table>

		</div>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'SelfOrganizationPrint',
		components: {
		},
		props: {
			assurance: {
				type: Object,
			}
		},
		data: () => ({
			html: '',
			userLoan: null
		}),
		mounted() {
			this.fillHtml()
		},
		computed: {
			...get('siteConfig', [
				'fullTitle'
			]),
			...get('appSettings', [
				'settings'
			]),
			businessTitle() {
				return this.settings?.businessTitle || this.fullTitle
			},
			assuranceTitle(){
				if (!this.assurance.coinType)				
					return `حدودا ${String(this.assurance.goldWeight).toPersianDigits()} گرم طلا`
				let coin = ''
				switch (this.assurance.coinType) {
					case 1:
						coin = 'ربع سکه'
						break;
					case 2:
						coin = 'نیم سکه'
						break;
					case 3:
						coin = 'ربع تمام بهار'
						break;
					case 4:
						coin = 'سکه گرمی'
						break;
					default:
						break;
				}
				return `${String(this.assurance.goldWeight).toPersianDigits()} عدد ${coin}`
			}
		},
		methods: {
			fillHtml() {
				this.getUserLoan().then(res => {
					this.userLoan = res
					this.$nextTick(() => {
						this.$emit('ready')
					})
				})
				// this.html = `مدیریت محترم حسابداری <span style="font-weight:bold">اداره مورد نظر</span>\r\nبا سلام و احترام،`
			},
			getUserLoan() {
				return api.get('admin/userLoan/get/' + this.assurance.userLoanId)
					.catch(err => {
						toast.error(err.message)
					})
			}
		}
	}
</script>
<style scoped></style>